import './Home.css';
import Category from '../../components/category/Category';
import { CategoryDetails } from '../../data/store-data';
import React, { useContext, useEffect } from 'react';
import { CheckoutContext, FlowsOptions, SourceOptions } from '../../store/CheckoutContext';
import { Grid, MenuItem, Select } from '@material-ui/core';
import { flowsOptionsValues } from '../../components/checkout/CheckoutForm';

interface Props {
  categories: CategoryDetails[];
}

const Home: React.FC<Props> = props => {
  const { flow, setFlow } = useContext(CheckoutContext);

  useEffect(() => {
    const search = window?.top?.location?.search;
    const params = new URLSearchParams(search);
    const flowFromParam = params.get('flow');

    if (flowFromParam) {
      setFlow(flowFromParam as FlowsOptions);
    }
  }, [setFlow]);

  return (
    <div className="Home">
      {props.categories.map(cat => (
        <Category key={cat.name} {...cat} />
      ))}

      <Grid item xs={12} sm={12}>
        <label className="checkout-error">
          <div style={{ marginLeft: '-23px' }}>Flow</div>
          <Select
            className="input"
            labelId="OrderSource"
            value={flow}
            onChange={event => setFlow(event.target.value as FlowsOptions)}
          >
            {flowsOptionsValues.map(item => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </label>
      </Grid>
    </div>
  );
};

export default Home;
